import "../styles/base.scss";

import { AppComponent } from "./app-component";

AppComponent.instance.init();



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/index.ts